const LANG_EN = 'en'
const LANG_ES = 'es'

const DEFAULT_LANGUAGE = LANG_EN

/** Thêm ngôn ngữ mới: bổ sung code ở đây và file tương ứng trong src/locales/ */
const LANGUAGES = [
    { code: LANG_EN, name: 'English', nativeName: 'English' },
    { code: LANG_ES, name: 'Spanish', nativeName: 'Español' },
]

export {
    LANG_EN,
    LANG_ES,
    DEFAULT_LANGUAGE,
    LANGUAGES,
}
